var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 55,
    viewBox: "0 0 51 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66016 30.2945C1.66016 23.7302 7.07505 17.8853 13.7487 17.8853C20.4224 17.8853 25.8303 23.7371 25.8303 30.2945",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8232 30.2929V13.014C25.8232 6.42203 20.3943 1.08203 13.6925 1.08203C6.99066 1.08203 1.66016 6.38744 1.66016 12.9794V30.2929",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.832 30.2945C25.832 23.7302 31.2469 17.8853 37.9206 17.8853C44.5943 17.8853 50.0021 23.7371 50.0021 30.2945",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9873 30.2929V13.014C49.9873 6.42203 44.5583 1.08203 37.8565 1.08203C31.1547 1.08203 25.8242 6.39436 25.8242 12.9794V30.2929",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8303 24.0884C25.8303 30.6527 20.4154 36.4976 13.7417 36.4976C7.06801 36.4976 1.66016 30.6458 1.66016 24.0884",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 24.0884V41.3673C1.66797 47.9593 7.09692 53.2993 13.7987 53.2993C20.5005 53.2993 25.831 47.9869 25.831 41.4019V24.0884",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilPicture);
export default __webpack_public_path__ + "static/media/profil-picture.3bbcc1a468ea8c418e2c410ba7e2d078.svg";
export { ForwardRef as ReactComponent };